export default {
  path: '/v5/server_manager',
  name: 'V5ServerManager',
  component: () => import('./ServerManagerPage.vue'),
};
